/** @typedef {'klarna'|'dejavoo'|string} PaymentGatewayKey */

export const PAYMENT_GATEWAY_KLARNA = 'klarna'

export function isBnplKlarnaSalePayment (payment) {
  if (!payment) return false
  const type = String(payment.payment_method_type || '').toLowerCase()
  if (type === 'bnpl_klarna') return true
  const details = payment.payment_details || {}
  return String(details.gateway || '').toLowerCase() === PAYMENT_GATEWAY_KLARNA
}

export function isKlarnaArPayment (paymentOrRow) {
  if (!paymentOrRow) return false
  const gateway = String(paymentOrRow.gateway || '').toLowerCase()
  const method = String(paymentOrRow.method || '').toLowerCase()
  if (gateway === PAYMENT_GATEWAY_KLARNA || method === PAYMENT_GATEWAY_KLARNA) return true
  return paymentOrRow.gateway_presentation?.is_klarna === true
}

export function formatGatewayStatusLabel (t, status) {
  if (!status) return '—'
  const key = `payments.gateway.status.${String(status).toLowerCase()}`
  const translated = t(key)
  return translated !== key ? translated : String(status)
}

/**
 * Extra reference line for AR payment history (Klarna request vs processor ref).
 * @param {import('vue-i18n').Composer['t']} t
 * @param {object|null|undefined} row
 * @returns {{ rawId: string|null, text: string|null }}
 */
export function formatGatewayReferenceSupplement (t, row) {
  const gt = row?.gateway_presentation?.gateway_transaction
  if (!gt) {
    return { rawId: null, text: null }
  }

  const isKlarna = isKlarnaArPayment(row) || gt.is_klarna === true
  if (isKlarna) {
    const id = gt.klarna_payment_request_id
    if (!id) {
      return { rawId: null, text: null }
    }
    return {
      rawId: String(id),
      text: t('payments.gateway.referenceKlarnaRequest', { id }),
    }
  }

  const id = gt.processor_transaction_id
  if (!id) {
    return { rawId: null, text: null }
  }
  const gateway = gt.gateway_label || gt.gateway || t('payments.gateway.colGateway')
  return {
    rawId: String(id),
    text: t('payments.gateway.referenceProcessor', { gateway, id }),
  }
}

/**
 * @param {object|null|undefined} transaction Gateway transaction summary from API
 * @returns {boolean}
 */
export function isKlarnaGatewayTransaction (transaction) {
  if (!transaction) return false
  if (transaction.is_klarna === true) return true
  return String(transaction.gateway || '').toLowerCase() === PAYMENT_GATEWAY_KLARNA
}
